/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

/* IMPORT SVG */
import ICONS from "../../../../../assets/Icons";

/* IMPORT CSS */
import "./index.css";

/* IMPORT COMPONENTS */
import SvgComponent from "../../../../../components/_utils/SVGComponent";
import TextInputField from "../../../../_utils/CommonInputFields/TextInputField";

/* IMPORT UTILS */
import {
  CATEGORY_ICON_IMAGES,
  custom_category_base_url,
} from "../../../../../utils/categoryIconMapper";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import TEXT from "../../../../../utils/globalText";
import { COLOR_CLASSES } from "../../../../../utils/categoriesIconColors";
const AddCategoryNameIcon = ({
  categoryName,
  setCategoryName,
  categoryDescription,
  setCategoryDescription,
  categoryIcon,
  setCategoryIcon,
  iconColor,
  setIconColor,
}) => {
  const defaultColor =
    Object.keys(COLOR_CLASSES)[GlobalConfiguration?.lengthCheckZero];
  const [selectedColor, setSelectedColor] = useState(iconColor || defaultColor);
  const handleInputChange = (event) => {
    const value = event.target.value.trimStart();
    if (value?.length <= GlobalConfiguration?.categorymaxLength) {
      setCategoryName(value);
    }
  };

  const handleInputDescriptionChange = (event) => {
    const value = event.target.value.trimStart();

    if (value?.length <= GlobalConfiguration?.inputMaxLength) {
      setCategoryDescription(value);
    }
  };

  const [isNameFocused, setIsNameFocused] = useState(false);
  const [isDescriptionFocused, setIsDescriptionFocused] = useState(false);

  const computeVariant = ({ value, focused, minLength, maxLength }) => {
    const trimmedLength = (value ?? "").trim().length;
    const actualLength = (value ?? "").length;

    // Empty input
    if (trimmedLength === GlobalConfiguration?.lengthCheckZero) {
      return focused ? TEXT?.TYPING : TEXT?.DEFAULT_SMALL;
    }

    // Valid range
    if (
      actualLength >= minLength &&
      actualLength <= maxLength &&
      trimmedLength > GlobalConfiguration?.lengthCheckZero
    ) {
      return TEXT?.VERIFIED_SMALL;
    }

    // Below minimum length
    if (
      trimmedLength > GlobalConfiguration?.lengthCheckZero &&
      actualLength < minLength
    ) {
      return focused ? TEXT?.TYPING : TEXT?.ERROR;
    }

    // Exceeds max length
    if (actualLength > maxLength) {
      return TEXT?.ERROR;
    }

    return TEXT?.DEFAULT_SMALL;
  };

  useEffect(() => {
    if (iconColor) {
      setSelectedColor(iconColor || defaultColor);
    }
  }, [iconColor]);

  // Push selected color to parent
  useEffect(() => {
    setIconColor(selectedColor);
  }, [selectedColor]);

  return (
    <>
      <div className="category-name-icon-page-container Qmd:mx-auto Qmd:max-w-tab-width-normal w-width-full overflow-y-scroll mb-[var(--stepper-moble-height)] Qmd:mb-margin-base">
        <div className="category-name-icon-page flex flex-col Qmd:flex-row gap-x-gap-xl gap-y-gap-md pt-padding-md Qsmd:pb-padding-md px-padding-md Qlg:px-padding-base pb-padding-md Qmd:mb-margin-base items-start bg-primary-bg">
          <div className="flex flex-col w-width-full Qmd:w-width-md Qmd:max-w-max_width-md gap-y-gap-md">
            <div className="bg-primary-card w-width-full flex flex-col p-padding-md rounded-border-radius-md">
              <p className="text-font-md text-text-primary font-semibold">
                {TEXT?.CATEGORY_NAME}
              </p>
              <div className="flex flex-col w-width-full mt-margin-md gap-y-gap-md">
                <TextInputField
                  bgColor="var(--primary-card)"
                  fgColor={
                    !categoryName?.length
                      ? "var(--text-secondary)"
                      : "var(--text-primary)"
                  }
                  placeholder={TEXT?.FIELD_NAME_LABEL}
                  adornment=""
                  variant={computeVariant({
                    value: categoryName?.trim(),
                    focused: isNameFocused,
                    minLength: GlobalConfiguration?.categoryminLength,
                    maxLength: GlobalConfiguration?.categorymaxLength,
                  })}
                  onFocus={() => setIsNameFocused(true)}
                  onBlur={() => setIsNameFocused(false)}
                  fontKind={TEXT?.BIG}
                  value={categoryName}
                  onInput={handleInputChange}
                />
                <TextInputField
                  isFullWidth
                  bgColor="var(--primary-card)"
                  fgColor={
                    !categoryDescription?.length
                      ? "var(--text-secondary)"
                      : "var(--text-primary)"
                  }
                  placeholder={TEXT?.DESCRIPTION_LABEL}
                  adornment=""
                  variant={computeVariant({
                    value: categoryDescription?.trim(),
                    focused: isDescriptionFocused,
                    minLength: GlobalConfiguration?.categoryminLength,
                    maxLength: GlobalConfiguration?.inputMaxLength,
                  })}
                  onFocus={() => setIsDescriptionFocused(true)}
                  onBlur={() => setIsDescriptionFocused(false)}
                  fontKind={TEXT?.BIG}
                  value={categoryDescription}
                  onInput={handleInputDescriptionChange}
                />
              </div>
            </div>
            <div className="bg-primary-card w-width-full flex flex-col gap-y-gap-md p-padding-md rounded-border-radius-md">
              <p className="text-font-md text-text-primary font-semibold">
                {TEXT?.SELECT_CATEGORY_ICON}
              </p>
              <div className="h-category_display_height bg-text-primary rounded-border-radius-sm overflow-hidden">
                <div className="category-image-alignment h-height-full w-width-full gap-gap-sm overflow-y-auto p-padding-md">
                  {Object.entries(CATEGORY_ICON_IMAGES)?.map(([name, url]) => {
                    const isSelected = categoryIcon === name;
                    return (
                      <div
                        key={name?.replace(".svg", "")}
                        className={`cursor-pointer flex items-center justify-center py-padding-sm ${
                          isSelected
                            ? `bg-${selectedColor} rounded-border-radius-sm`
                            : ""
                        }`}
                        onClick={() => setCategoryIcon(name)}
                      >
                        <SvgComponent
                          url={url}
                          height={"var(--icon-lg)"}
                          width={"var(--icon-lg)"}
                          color={
                            isSelected
                              ? "var(--text-primary)"
                              : `var(--${selectedColor})`
                          }
                          alt={name?.replace(".svg", "")}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="flex flex-col w-width-full gap-y-gap-sm">
                <p className="text-font-md text-text-primary font-semibold">
                  {TEXT?.CHOOSE_COLOR}
                </p>
                <div className="flex flex-row gap-x-gap-sm">
                  {Object.keys(COLOR_CLASSES)?.map((color, index) => (
                    <div
                      key={index}
                      onClick={() => setSelectedColor(color)}
                      className={`w-icon-lg h-icon-lg rounded-large flex items-center justify-center cursor-pointer ${COLOR_CLASSES[color]}`}
                    >
                      {selectedColor === color && (
                        <SvgComponent
                          url={ICONS?.CHECK_MARK_WHITE}
                          color="var(--text-primary)"
                          height={"var(--icon-md)"}
                          width={"var(--icon-md)"}
                          alt={TEXT?.CURRENT_SELECTED_COLOR}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${
              categoryName?.trim() !== "" &&
              categoryIcon &&
              categoryDescription?.trim() !== ""
                ? "block w-width-full"
                : "invisible"
            } Qmd:w-width-md Qmd:max-w-max_width-md`}
          >
            <div className="bg-primary-card flex flex-col gap-y-gap-md p-padding-md rounded-border-radius-md w-width-full">
              <p className="text-font-md text-text-primary font-semibold">
                {TEXT?.PREVIEW}
              </p>
              <div className="flex flex-row w-width-full bg-primary-nav-act rounded-border-radius-md">
                <div className="flex items-center justify-center p-padding-sm bg-text-primary rounded-l-border-radius-md">
                  <SvgComponent
                    url={`${custom_category_base_url}/${categoryIcon}`}
                    height={"var(--icon-lg)"}
                    width={"var(--icon-lg)"}
                    color={`var(--${selectedColor})`}
                  />
                </div>
                <div className="flex flex-col gap-y-gap-xs p-padding-sm pr-padding-md w-width-full overflow-hidden">
                  <p className="text-font-sm text-text-primary font-semibold">
                    {categoryName}
                  </p>
                  <p className="text-font-xs text-text-secondary font-normal break-all">
                    {/* <TickerAnimation text={categoryDescription} /> */}
                    {categoryDescription}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategoryNameIcon;
